import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { MsalService } from '@azure/msal-angular';

// bootstrapApplication(App, appConfig)
//   .catch((err) => console.error(err));

bootstrapApplication(App, appConfig)
  .then((appRef) => {
    const msal = appRef.injector.get(MsalService);

    return msal.instance.initialize().then(() => {
      const accounts = msal.instance.getAllAccounts();

      if (!msal.instance.getActiveAccount() && accounts.length > 0) {
        msal.instance.setActiveAccount(accounts[0]);
      }
    });
  })
  .catch((err) => console.error(err));